<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">{{ 'publicWifi.details.title' | translate }}</h1>

          <div class="rs-panel-big rs-bg-c2 clearfix">
            <h2 class="rs-tit3">{{ 'publicWifi.pxsplus.configuration.no_simcard' | translate }}</h2>
            <p [innerHTML]="'publicWifi.pxsplus.configuration.description' | translate: true"></p>
          </div>

          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
